import { Fragment } from "react";
import { bio, profile, projects, skills } from "./data/portfolio";
import { contactConfig } from "./data/contact";

// ponytail: email is parsed out of the form endpoint to avoid a second source of truth.
const email = contactConfig.endpoint.split("/").pop();

const css = `
.rec{--ink:#1a1a1a;--mute:#5c5c5c;--line:#e3e3e3;background:#fff;color:var(--ink);min-height:100vh;
  font:16px/1.6 system-ui,-apple-system,"Segoe UI",sans-serif}
.rec main{max-width:720px;margin:0 auto;padding:3rem 1.25rem 4rem}
.rec h1{font-size:2rem;line-height:1.2;margin:0}
.rec h2{font-size:.8rem;letter-spacing:.1em;text-transform:uppercase;color:var(--mute);
  border-bottom:1px solid var(--line);padding-bottom:.4rem;margin:2.5rem 0 1rem}
.rec h3{font-size:1rem;margin:0}
.rec p{margin:.4rem 0}
.rec a{color:#0b57d0}
.rec .sub{color:var(--mute)}
.rec .row{display:flex;gap:1rem;flex-wrap:wrap;margin-top:1rem}
.rec .btn{border:1px solid var(--ink);padding:.4rem .9rem;border-radius:4px;color:var(--ink);text-decoration:none}
.rec .btn.primary{background:var(--ink);color:#fff}
.rec .item{margin-bottom:1.25rem}
.rec dl{display:grid;grid-template-columns:max-content 1fr;gap:.35rem 1.25rem;margin:0}
.rec dt{color:var(--mute)}.rec dd{margin:0}
.rec footer{margin-top:3rem;font-size:.85rem;color:var(--mute)}
`;

export default function Recruiter() {
  return (
    <div className="rec">
      <style>{css}</style>
      <main>
        <h1>{profile.name}</h1>
        <p className="sub">{profile.title} · {profile.company} · {profile.location}</p>
        <div className="row">
          <a className="btn primary" href="/resume.pdf" target="_blank" rel="noopener noreferrer">Resume (PDF)</a>
          <a className="btn" href={`mailto:${email}`}>{email}</a>
        </div>

        <h2>Summary</h2>
        <p>{bio.intro}</p>
        {bio.paragraphs.map((p) => <p key={p}>{p}</p>)}

        <h2>Skills</h2>
        <dl>
          {skills.map((g) => (
            <Fragment key={g.category}><dt>{g.category}</dt><dd>{g.items.map((i) => i.label).join(", ")}</dd></Fragment>
          ))}
        </dl>

        <h2>Projects</h2>
        {projects.map((p) => (
          <div className="item" key={p.title}>
            <h3>{p.link ? <a href={p.link} target="_blank" rel="noopener noreferrer">{p.title}</a> : p.title}</h3>
            <p>{p.description}</p>
            <p className="sub">{p.tags.join(" · ")}</p>
          </div>
        ))}

        <footer><a href="/">See the interactive version →</a></footer>
      </main>
    </div>
  );
}
